import Header from 'components/organisms/Header/HomeHeader';
import './Create.css';
import { useNavigate } from 'react-router-dom';

export const Create = () => {
  const navigate = useNavigate();
  return (
    <>
      <Header />
      <div className="body-div">
        <>
          <div className="container-div">
            {/* <div
              className="container-1"
              onClick={() => navigate('/create/nft')}
            >
              <div className="box-1">
                <h1>Create NFT</h1>
              </div>
            </div> */}
            <div
              onClick={() => navigate('/create/otr')}
              className="container-1"
            >
              <div className="box-1">
                <h1>Create OTR</h1>
              </div>
            </div>
          </div>
        </>
      </div>
    </>
  );
};
